export default function ReceiptIcon({ name }) {
  const paths = {
    check: <path d="m6 12.5 3.5 3.5L18 7.5" />,
    car: <><path d="m5 16-1-1v-4l2-5h12l2 5v4l-1 1"/><path d="M6 16v2M18 16v2M4 12h16M7 13h.01M17 13h.01"/></>,
    user: <><circle cx="12" cy="8" r="3.5"/><path d="M5 20c.5-4 3-6 7-6s6.5 2 7 6"/></>,
    speed: <><path d="M4 16a8 8 0 1 1 16 0"/><path d="m12 14 4-4M4 19h16"/></>,
    calendar: <><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/></>,
    receipt: <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2Z"/><path d="M9 8h6M9 12h6M9 16h3"/></>,
    share: <><circle cx="18" cy="5" r="2"/><circle cx="6" cy="12" r="2"/><circle cx="18" cy="19" r="2"/><path d="m8 11 8-5M8 13l8 5"/></>,
    history: <><path d="M4 12a8 8 0 1 0 2-5.3L4 9"/><path d="M4 4v5h5M12 8v5l3 2"/></>,
    plus: <path d="M12 5v14M5 12h14"/>,
    dashboard: <><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></>,
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true">{paths[name] || paths.receipt}</svg>;
}
